module.exports = __webpack_public_path__ + "img/0cjp4dka.1d90cd22.png";